uniform sampler2D uTexture;
uniform float uBrightness;
uniform float uContrast;

varying vec2 vUv;

void main() {
    vec4 texColor = texture2D(uTexture, vUv);

    // Apply contrast: scale around mid-gray (0.5)
    vec3 color = (texColor.rgb - 0.5) * uContrast + 0.5;

    // Apply brightness: additive offset
    color += uBrightness;

    // Clamp to valid range
    color = clamp(color, 0.0, 1.0);

    gl_FragColor = vec4(color, texColor.a);
}